// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__xykc2","col":"styles_col__26t66"};